export const COGNITO_CONFIG = {
  UserPoolId: "ap-south-1_DUil3CokS",
  ClientId: "20qduhbkr9t25k1n2q9b1jfo93",
  Region: "ap-south-1",
  IdentityPoolId: "ap-south-1:6a6d25f6-7714-414f-983e-bb22fc7a2230",
  domain: "360customizer.auth.ap-south-1.amazoncognito.com",
};
